export default function (dom, opts) {
    let options = {
        hideCls: 'hide-single',
        formFieldsetSel: 'form fieldset',
        contactSel: '.contact-box__content',
        contactCls: 'contact-box__content',
				categorySel: '[name="contactCategory"]',
        recipientSel: '[name="recipient"]',
        boxClose: '[data-close-box]',
        showOverlay: 'contact-overlay',
        ...opts
    };

    const html = document.documentElement;
    const contacts = Array.from(dom.querySelectorAll(options.contactSel));
    const recipient = dom.querySelector(options.recipientSel);
		const category = dom.querySelector(options.categorySel);
    const contactsFormFieldSet = dom.querySelector(options.formFieldsetSel);

    function init() {

        document.querySelector(options.boxClose).addEventListener('click', onClose);

        if (contacts[0].dataset.email) {
            recipient.value = contacts[0].dataset.email;
        }

				if (contacts[0].dataset.category){
						category.value = contacts[0].dataset.category;
				}
    }

    function onClose() {
        html.classList.remove(options.showOverlay);
		}

    init();

}
